import config from 'config/config'
import { azureLogOut, clearSession } from '../store/actions/auth'

export function idleTimer (instance) {
  let t
  window.onmousemove = resetTimer
  window.onmousedown = resetTimer
  window.onclick = resetTimer
  window.onscroll = resetTimer
  window.onkeyup = resetTimer
  window.onkeydown = resetTimer
  function idle () {
    clearSession()
    azureLogOut(instance)
  }

  function resetTimer () {
    clearTimeout(t)
    t = setTimeout(idle, config.idleTimeout)
  }
}
